import { Outlet } from "react-router";
import { CatalogRail } from "./CatalogRail";

// The settings shell renders a sticky h-14 breadcrumb at top-[var(--banner-h)],
// so the rail needs to stick just below it.
const RAIL_TOP = "calc(var(--banner-h) + 3.5rem)";

export function CatalogShell() {
  return (
    <div className="flex">
      <aside className="w-[296px] hair-r border-r bg-paper flex-shrink-0">
        <div
          className="sticky overflow-y-auto"
          style={{
            top: RAIL_TOP,
            maxHeight: `calc(100vh - ${RAIL_TOP})`,
          }}
        >
          <CatalogRail />
        </div>
      </aside>
      <section className="flex-1 min-w-0 bg-paper-hi">
        <Outlet />
      </section>
    </div>
  );
}
